import React, { createRef } from 'react';
import PropTypes from 'prop-types';

import { BorderRadius, Colors, FontSizes } from '../Theme';

const FileField = ({ invalid, onChange, file, fileUrl, readOnly }) => {
  const styles = {
    component: {
      cursor: readOnly ? 'default' : 'pointer',
      backgroundColor: readOnly ? '#f5f5f5' : '#fff',
      borderRadius: BorderRadius.DEFAULT,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: invalid ? Colors.RED.hex : '#ccc',
      fontSize: FontSizes.MEDIUM,
      height: 40,
      lineHeight: '20px',
      padding: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    value: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    icon: {
      marginLeft: 10,
      fontSize: 18,
      color: Colors.PRIMARY.hex
    }
  };
  const newFileInput = createRef();

  const handleFileChange = e => {
    if (e.target.files.length) {
      onChange(e.target.files[0]);
    }
  };

  const changeFile = e => {
    newFileInput.current.click();
    e.stopPropagation();
  };

  const revertFile = e => {
    e.stopPropagation();
    newFileInput.current.value = null;
    onChange(null);
  };

  return (
    <div onClick={readOnly ? null : changeFile} style={styles.component}>
      <input
        onChange={handleFileChange}
        ref={newFileInput}
        style={{ display: 'none' }}
        type='file'
      />

      <div style={styles.value}>{file ? file.name || file.url : fileUrl || 'No file selected'}</div>

      {readOnly ? null : (
        <>
          {file ? (
            <i
              className='mdi mdi-close-circle-outline'
              onClick={revertFile}
              style={{ ...styles.icon, color: Colors.RED.hex }}
            />
          ) : (
            <i className='mdi mdi-upload' style={styles.icon} />
          )}
        </>
      )}
    </div>
  );
};

FileField.propTypes = {
  file: PropTypes.object,
  fileUrl: PropTypes.string,
  invalid: PropTypes.bool,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool
};

export default FileField;
